module.exports = __webpack_public_path__ + "img/收礼物.fab01529.png";